/* eslint-disable jsx-a11y/alt-text */
import React from "react";

const InfoActionPage = ({ title, message, image, action }) => {
	return (
		<div className="confirm-account-wrapper">
			<div className="wrapper-inner">
				<div className="action-box">
					<div className="box-content">
						<img
							className="light-image"
							src={image ||
								require("../assets/images/undraw_verified_re_4io7.svg")
									.default
							}
							alt
						/>
						<img
							className="dark-image"
							src={image||
								require("../assets/img/illustrations/placeholders/launch-dark.svg")
									.default
							}
							alt
						/>
						<h3 className="dark-inverted">{title ||"Suspended Account"}</h3>
						<p style={{ fontSize: '1.15rem', fontWight: 'inherit' }}>
							{message || `Your account is at risk of suspension on Sunday, Nov 21 due to an
							overdue balance of $20.00. To prevent service termination and loss
							of data due to nonpayment, please log in to your Billing Settings
							page page and make an immediate payment.`}
						</p>
						{action ? (
							<div className="buttons">
							<button onClick={action.action} className="button h-button is-primary is-raised">
								{action?.text || "Go to Billing"}
							</button>
						</div>
						): null}
					</div>
				</div>
			</div>
		</div>
	);
};

export default InfoActionPage;
